<form
  class="bg-surface border-default flex w-full flex-col overflow-hidden rounded-lg border shadow-lg"
  aria-labelledby="route-resources-title"
  (submit)="$event.preventDefault(); apply()">
  <div class="border-weak flex items-center gap-2 border-b px-3 py-2.5">
    <i class="text-accent-main" [class]="isNew() ? ICONS.plus : ICONS.truck"></i>
    <h2
      id="route-resources-title"
      class="text-text-primary min-w-0 flex-1 truncate text-sm font-semibold">
      {{
        (isNew()
          ? 'features.plan.edit.resources.new_title'
          : 'features.plan.edit.resources.title'
        ) | translate
      }}
    </h2>
    <button
      type="button"
      class="text-text-tertiary hover:text-text-primary shrink-0 cursor-pointer rounded-xs transition-colors"
      [attr.aria-label]="'common.close' | translate"
      (click)="done.emit()">
      <i [class]="ICONS.x"></i>
    </button>
  </div>

  <div class="flex flex-col gap-3 p-3">
    @if (then() && carriedName(); as name) {
      <p class="text-text-secondary text-xs" data-testid="new-route-then">
        {{ 'features.plan.edit.resources.then' | translate: { name } }}
      </p>
    }
    @for (field of fields(); track field.kind) {
      <div class="flex flex-col gap-1">
        <span [id]="'route-resources-' + field.kind" class="form-label mb-0 text-xs">
          {{ 'features.plan.edit.resources.' + field.kind | translate }}
        </span>
        <div class="flex items-center gap-1">
          <button
            type="button"
            [attr.data-testid]="'resource-' + field.kind"
            [attr.aria-labelledby]="'route-resources-' + field.kind"
            class="form-input flex min-w-0 flex-1 cursor-pointer items-center gap-2 text-left"
            (click)="pick(field.kind)">
            <i class="text-text-secondary shrink-0" [class]="field.icon"></i>
            @if (field.value) {
              <span class="text-text-primary min-w-0 flex-1 truncate font-mono text-sm">
                {{ resourceName(field.kind, field.value) }}
              </span>
            } @else {
              <span class="text-text-tertiary min-w-0 flex-1 truncate text-sm">
                {{ 'features.plan.edit.resources.none' | translate }}
              </span>
            }
          </button>
          @if (!field.required && field.value) {
            <button
              type="button"
              [attr.data-testid]="'clear-' + field.kind"
              class="text-text-tertiary hover:text-text-primary shrink-0 cursor-pointer rounded-xs p-1 transition-colors"
              [attr.aria-label]="'features.plan.edit.resources.clear' | translate"
              (click)="clear($any(field.kind))">
              <i [class]="ICONS.x"></i>
            </button>
          }
        </div>
        @if (registrationField(field.kind); as registration) {
          <div class="border-accent-border mt-0.5 flex flex-col gap-1 border-l-2 pl-3">
            <label
              class="form-label mb-0 text-xs"
              [for]="'route-registration-' + field.kind">
              {{ 'features.plan.edit.resources.registration' | translate }}
            </label>
            <app-select
              [id]="'route-registration-' + field.kind"
              [attr.data-testid]="'registration-' + field.kind"
              [items]="registration.items"
              [value]="registration.value"
              (valueChange)="pickRegistration(registration.kind, $event)" />
            <p class="form-help">
              {{ 'features.plan.edit.resources.registration_help' | translate }}
            </p>
          </div>
        }
        @if (field.kind === 'vehicle') {
          @for (other of vehicleAlsoOn(); track other.routeUid) {
            <p class="form-help flex items-center gap-1.5" data-testid="vehicle-also-on">
              <span class="min-w-0 flex-1">
                {{ 'features.plan.edit.resources.also_on' | translate }}
                <span class="font-mono">{{ other.name }}</span>
              </span>
              @if (!isNew()) {
                <button
                  type="button"
                  data-testid="swap-instead"
                  class="text-accent-main hover:text-accent-hover shrink-0 cursor-pointer rounded-xs transition-colors"
                  (click)="swapInstead(other.routeUid)">
                  {{ 'features.plan.edit.resources.swap_instead' | translate }}
                </button>
              }
            </p>
          }
        }
      </div>
    }
  </div>

  <div class="border-weak flex items-center justify-end gap-2 border-t px-3 py-2.5">
    <button type="button" class="btn btn-cancel" (click)="done.emit()">
      {{ 'common.cancel' | translate }}
    </button>
    <button
      type="submit"
      data-testid="resources-submit"
      class="btn btn-primary"
      [disabled]="!canApply()">
      {{
        (isNew()
          ? 'features.plan.edit.resources.open'
          : 'features.plan.edit.resources.apply'
        ) | translate
      }}
    </button>
  </div>
</form>
